import clockIn from '../Services/clockIn'

export default () => (dispatch) => {

  dispatch(clockIn())

}
